import ClientNotificationInterface from '../../interfaces/client/Notification'

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'

export default (notification: ClientNotificationInterface) => ({
  type: ADD_NOTIFICATION,
  notification,
})
